import { Link } from "react-router-dom";

const categories = [
  { name: "剧情", icon: "ri-book-open-line", desc: "人物与命运的拉扯" },
  { name: "爱情", icon: "ri-heart-3-line", desc: "关系里的微妙时刻" },
  { name: "悬疑", icon: "ri-search-eye-line", desc: "线索与反转的地图" },
  { name: "古装", icon: "ri-ancient-gate-line", desc: "东方美学新表达" },
  { name: "犯罪", icon: "ri-shield-keyhole-line", desc: "灰度地带的追问" },
  { name: "年代", icon: "ri-time-line", desc: "旧时光里的群像" },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((category) => (
        <Link
          key={category.name}
          to={`/category?genre=${encodeURIComponent(category.name)}`}
          className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-700 transition-colors group-hover:bg-accent-100 group-hover:text-accent-700">
            <i className={`${category.icon} text-xl`} aria-hidden="true" />
          </span>
          <span className="mt-3 font-heading text-sm font-bold text-foreground-900">{category.name}</span>
          <span className="mt-1 text-xs leading-5 text-foreground-500">{category.desc}</span>
        </Link>
      ))}
    </div>
  );
}